import type { LightboxState } from './types';

export const MIN_ZOOM = 1;
export const MAX_ZOOM = 3;
export const ZOOM_STEP = 0.5;

export function createState(): LightboxState {
    return {
        currentImages: [],
        currentIndex: 0,
        zoomLevel: 1,
        isDragging: false,
        isOpen: false,
        startX: 0,
        startY: 0,
        translateX: 0,
        translateY: 0,
        lastTranslateX: 0,
        lastTranslateY: 0,
        initialPinchDistance: 0,
        initialZoom: 1,
        touchStartX: 0,
        touchStartY: 0
    };
}
